import styled from "styled-components";
import { Flex } from "../ProposalModal/styles";

export const EstimationLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 0;
`;

export const TotalHoursContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  padding-left: 5px;
`;

export const TotalHours = styled.div`
  margin-left: 6px;
  font-size: 18px;
  font-weight: 600;
  color: var(--light-orange);
`;

export const ContainerFlex = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  border: 2px solid #ddd;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
`;
